import './scss/vitrine.scss'
import { MidiaProdutoVitrine } from "../components/MidiaProdutoVitrine"
import type { VitrineTipo3Props } from "../types/vitrineApp.props"
import { getLinkProduto } from "@/utils/getLinkProduto"
import { parseISO, isAfter, isBefore } from 'date-fns'
import { ZordUtil } from '@/utils/Zord'
import { ValuesArea } from './components/ValuesArea'
import { OfertaComprarCountdown } from './components/OfertaComprarCountdown'

export function RenderVitrineTipo3({
    produtos,
    exibeQuantidadeEstoque,
    escondePrecoFuturo,
    tituloVitrine,
    exibeValoresSomenteLogado,
    precoPrincipal,
    vitrineButtonAddToCart,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    width,
    height
}: VitrineTipo3Props) {
    return (
        <>
            {tituloVitrine && (
                <div className="title-ctn">
                    <h2 className="bg-title">
                        <span dangerouslySetInnerHTML={{ __html: tituloVitrine }} />
                    </h2>
                </div>
            )}
            <div className="container">
                <div className="macro-vitrine-landing-page">
                    {Object.values(produtos).map((produto, i) => {
                        const dataAtual = new Date()

                        let ofertaEstoqueDisponivel = produto.qtde_estoque > 0

                        if (
                            produto.vitrine_opcoes &&
                            produto.vitrine_opcoes.qtde_disponivel != null &&
                            produto.vitrine_opcoes.qtde_vendida != null &&
                            produto.vitrine_opcoes.qtde_vendida >= produto.vitrine_opcoes.qtde_disponivel
                        ) {
                            ofertaEstoqueDisponivel = false
                        }

                        let etapaOferta = 3
                        let linkOferta = getLinkProduto(produto)

                        const dataInicio = produto.data_inicio ? parseISO(produto.data_inicio) : null
                        const dataInicioNaoDefinidaOuVazia = !produto.data_inicio || produto.data_inicio.trim() === ''

                        if (ofertaEstoqueDisponivel && (dataInicioNaoDefinidaOuVazia || (dataInicio && isBefore(dataInicio, dataAtual)))) {
                            etapaOferta = 2

                            if (produto.anuncio) {
                                linkOferta += `?an=${produto.anuncio}`
                            }
                        } else if (dataInicio && isAfter(dataInicio, dataAtual)) {
                            etapaOferta = 1
                        } else {
                            etapaOferta = 3
                        }

                        return (
                            <div key={i} className={`line-product ${exibeValoresSomenteLogado ? 'vitrine-valores-logados' : ''}`}>
                                <a href={ZordUtil.webPath(linkOferta)} title={linkOferta}>
                                    <div className="info-oferta">
                                        <div className="img-product">
                                            <MidiaProdutoVitrine
                                                produto={produto}
                                                width={width}
                                                height={height}
                                                hoverImagensVitrine={hoverImagensVitrine}
                                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                            />
                                        </div>

                                        <div className="informacao-descricao-produto">
                                            <div className="header-product">
                                                <div className="name-product">
                                                    <h3>{produto.titulo || [produto.nome, produto.derivacao_nome].filter(Boolean).join(' ')}</h3>
                                                </div>

                                                {produto.complemento && (
                                                    <p className="complemento-titulo">{produto.complemento}</p>
                                                )}
                                            </div>
                                            
                                            {exibeValoresSomenteLogado ? (
                                                <div className="preco-compra">
                                                    <div className="valores-logados-vitrine">
                                                        <span>
                                                            Faça login para ver os preços
                                                        </span>

                                                        <a
                                                            href={ZordUtil.webPath(`login?redir=${encodeURIComponent(window.location.pathname)}`)}
                                                            className="btn-comprar-vitrine flex center justify-center"
                                                        >
                                                            Fazer login
                                                        </a>
                                                    </div>
                                                </div>
                                            ) : (
                                                <ValuesArea
                                                    produto={produto}
                                                    etapaOferta={etapaOferta}
                                                    escondePrecoFuturo={escondePrecoFuturo}
                                                    precoPrincipal={precoPrincipal}
                                                    exibeQuantidadeEstoque={Boolean(exibeQuantidadeEstoque)}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {!exibeValoresSomenteLogado && (
                                        <OfertaComprarCountdown
                                            produto={produto}
                                            precoPrincipal={precoPrincipal}
                                            escondePrecoFuturo={escondePrecoFuturo}
                                            etapaOferta={etapaOferta}
                                            ofertaEstoqueDisponivel={ofertaEstoqueDisponivel}
                                            vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        />
                                    )}
                                </a>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

